import { Col, Row } from "antd";
import HexButton from "../../../ui-kit/HexButtons";
import { getLabel } from "../../../hooks/use-labels";

const FilterFooterButton = ({ buttonText, className, onClick }) => {
  return (
    <Row className={className || ""}>
      <Col md={24}>
        <div className="filteration-btn">
          <HexButton
            label={buttonText || getLabel("filterSaveText")}
            type="primary"
            size="lg"
            onClick={onClick}
          />
        </div>
      </Col>
    </Row>
  );
};

export default FilterFooterButton;
